<template>
  <v-menu
    bottom
    left
    offset-y
    content-class="bi-parameter-rule-row-actions-menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        @click.stop
      >
        <v-icon color="primary" size="20">
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item
        v-if="canEdit"
        class="bi-parameter-rule-row-action-item primary--text"
        @click.stop="$emit('edit', item)"
      >
        <v-list-item-icon class="bi-parameter-rule-row-action-item__icon">
          <v-icon size="18">mdi-pencil-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ $t('biControlPanel.parameterRules.actions.edit') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        class="bi-parameter-rule-row-action-item primary--text"
        @click.stop="$emit('rule-history', item)"
      >
        <v-list-item-icon class="bi-parameter-rule-row-action-item__icon">
          <v-icon size="18">mdi-history</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ $t('biControlPanel.parameterRules.actions.ruleHistory') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        class="bi-parameter-rule-row-action-item primary--text"
        @click.stop="$emit('parameter-history', item)"
      >
        <v-list-item-icon class="bi-parameter-rule-row-action-item__icon">
          <v-icon size="18">mdi-text-box-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ $t('biControlPanel.parameterRules.actions.parameterHistory') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="canEdit"
        class="bi-parameter-rule-row-action-item primary--text"
        @click.stop="$emit('toggle-rule', item)"
      >
        <v-list-item-icon class="bi-parameter-rule-row-action-item__icon">
          <v-icon size="18">
            {{ item.ruleActive ? 'mdi-cancel' : 'mdi-check-circle-outline' }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ item.ruleActive
            ? $t('biControlPanel.parameterRules.actions.deactivateRule')
            : $t('biControlPanel.parameterRules.actions.activateRule')
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'BIParameterRuleRowActionsMenu',
  props: {
    item: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.bi-parameter-rule-row-actions-menu {
  .bi-parameter-rule-row-action-item {
    min-height: 40px;
    padding: 0 12px;

    &__icon {
      align-self: center;
      justify-content: center;
      margin: 0 12px 0 0 !important;
      min-width: 24px !important;
    }

    .v-list-item__title {
      flex: 1 1 auto;
    }
  }
}
</style>
